@use '../../../scss/utility';
@use 'banner-teaser-vars';

:host {
  @include banner-teaser-vars.wb-banner-teaser-vars;

  display: block;
  position: relative;
}

.wrapper {
  position: relative;
  color: var(--banner-teaser-wrapper-color);
  background-color: var(--banner-teaser-wrapper-background-color);
  padding: var(--banner-teaser-wrapper-padding);
}

.wb-aspect-ratio {
  height: 100%;
  min-height: utility.wb-pixel-to-rem(360px);
}

.gradient {
  position: absolute;
  inset-block-start: calc(var(--wb-spacing-m));
  inset-inline-start: 0;
  width: 100%;
  height: calc(100% - var(--wb-spacing-m) * 2);
  background-image: var(--banner-teaser-gradient-background-image);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tags {
  display: flex;
  position: relative;
  gap: var(--wb-spacing-xxs);
  padding: var(--wb-spacing-xs);
  z-index: 1;
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--wb-spacing-xxs);
}

::slotted(.wb-heading) {
  margin-block-end: var(--banner-teaser-heading-margin-block-end);
}

::slotted(.wb-text) {
  margin-block-end: var(--wb-spacing-xs);
}

::slotted(.wb-input[slot='footer']) {
  @include utility.breakpoint-to('mq2') {
    flex-basis: 100%;
  }

  @include utility.breakpoint-between('mq3', 'mq4') {
    flex: 1;
  }

  @include utility.breakpoint-from('mq4') {
    width: calc(4 * var(--wb-grid-column-width) + 3 * var(--wb-grid-gutter-width));
  }
}

@include utility.breakpoint-to('mq2') {
  .content {
    margin: 0 auto;
    width: var(--wb-grid-width);
  }
}

@include utility.breakpoint-from('mq3') {
  .wrapper {
    display: flex;
    margin-inline-start: calc(50% - var(--wb-grid-width) / 2);
    gap: var(--wb-grid-gutter-width);
  }

  .wb-aspect-ratio {
    width: calc(var(--wb-grid-column-width) * 4 + var(--wb-grid-gutter-width) * 3);
  }

  .content {
    width: calc(var(--wb-grid-column-width) * 8 + var(--wb-grid-gutter-width) * 7);
  }
}

@include utility.breakpoint-between('mq3', 'mq5') {
  .wrapper {
    margin-inline-start: 0;
  }

  .wb-aspect-ratio {
    width: calc((50% - var(--wb-grid-width) / 2) + var(--wb-grid-column-width) * 4 + var(--wb-grid-gutter-width) * 3);
  }
}

:host([full-width]) {
  @include banner-teaser-vars.wb-banner-teaser-full-width-vars;

  @include utility.breakpoint-from('mq3') {
    @include banner-teaser-vars.wb-banner-teaser-full-width-desktop-vars;
  }

  .content {
    position: absolute;
    inset-block-start: 50%;
    transform: translateY(-50%);
    inset-inline-start: utility.wb-pixel-to-rem(64px);
  }

  .wb-aspect-ratio {
    width: 100%;
  }
}

:host(:not([full-width])) {
  @include utility.breakpoint-to('mq2') {
    .wb-aspect-ratio {
      margin-block-end: var(--wb-spacing-s);
    }
  }

  ::slotted(.wb-button[slot='footer']) {
    @include utility.breakpoint-to('mq2') {
      flex-basis: 100%;
    }
  }
}

:host(:not([top-padding='false'])) {
  @include banner-teaser-vars.wb-banner-teaser-top-padding-vars;
}
